module.exports = __webpack_public_path__ + "img/mn.b6529a3.svg";